import React from "react";
import NeoValidador from "./NeoValidador";

const MainRouter = () => {
  return <NeoValidador />;
};

export default MainRouter;
